import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventHeaderComponent } from './event-header/event-header.component';
import { MainDetailComponent } from './main-detail/main-detail.component';
import { EventKeysComponent } from './event-keys/event-keys.component';
import { EventActivitiesComponent } from './event-activities/event-activities.component';
import { EventDetailComponent } from './event-detail/event-detail.component';
import { EventSpeakerComponent } from './event-speaker/event-speaker.component';
import { EventLocationComponent } from './event-location/event-location.component';
import { EventGiftComponent } from './event-gift/event-gift.component';
import { EventPartnerComponent } from './event-partner/event-partner.component';



@NgModule({
  declarations: [
    EventHeaderComponent,
    MainDetailComponent,
    EventKeysComponent,
    EventDetailComponent,
    EventActivitiesComponent,
    EventSpeakerComponent,
    EventLocationComponent,
    EventGiftComponent,
    EventPartnerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    EventHeaderComponent,
    MainDetailComponent,
    EventKeysComponent,
    EventDetailComponent,
    EventActivitiesComponent,
    EventSpeakerComponent,
    EventLocationComponent,
    EventGiftComponent,
    EventPartnerComponent
  ]
})
export class EventSharedModule { }
